/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Reason_DiscomfortInputs */

const en_us2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It bothers me`)
};

const pt_br2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomoda`)
};

const es_419_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me molesta`)
};

const pt_pt2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incomoda-me`)
};

const fr_fr2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça me gêne`)
};

const de_de2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stört mich`)
};

const it_it2_swap_reason_discomfort = /** @type {(inputs: Swap_Reason_DiscomfortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mi dà fastidio`)
};

/**
* | output |
* | --- |
* | "It bothers me" |
*
* @param {Swap_Reason_DiscomfortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_reason_discomfort = /** @type {((inputs?: Swap_Reason_DiscomfortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Reason_DiscomfortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_reason_discomfort(inputs)
	if (locale === "es-419") return es_419_swap_reason_discomfort(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_reason_discomfort(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_reason_discomfort(inputs)
	if (locale === "de-DE") return de_de2_swap_reason_discomfort(inputs)
	if (locale === "it-IT") return it_it2_swap_reason_discomfort(inputs)
	return en_us2_swap_reason_discomfort(inputs)
});
export { swap_reason_discomfort as "swap.reason_discomfort" }